import "./index.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { FeedbackHost } from "./components/ui-kit";
import LoginPage from "./pages/LoginPage";
import AdminPanel from "./pages/admin/AdminPanel";
import ConductorPanel from "./pages/conductor/ConductorPanel";
import VendedorPanel from "./pages/vendedor/VendedorPanel";

function PerfilSinPanel() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-stone-100 px-4 py-10">
      <div className="mx-auto max-w-xl rounded-[28px] border border-stone-200 bg-white p-8 shadow-[0_20px_60px_rgba(28,25,23,0.08)]">
        <p className="text-xs font-semibold uppercase tracking-[0.28em] text-stone-500">
          Acceso autenticado
        </p>
        <h1 className="mt-4 text-2xl font-semibold text-stone-950">
          Este perfil aún no tiene un panel asignado
        </h1>
        <p className="mt-3 text-sm leading-6 text-stone-600">
          El usuario {user?.profile?.razon_social ?? user?.username} ingresó correctamente, pero su rol actual no apunta a una vista operativa dentro de la SPA.
        </p>
        <button
          onClick={logout}
          className="mt-6 rounded-2xl bg-stone-950 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-stone-700"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}

function AppRouter() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-stone-100 px-4">
        <div className="rounded-[32px] border border-white/80 bg-white px-10 py-8 text-center shadow-[0_28px_80px_rgba(28,25,23,0.10)]">
          <div className="mx-auto flex h-18 w-18 items-center justify-center rounded-full bg-red-50 shadow-[0_18px_36px_rgba(212,42,42,0.12)]">
            <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-[#d42a2a] border-t-transparent" />
          </div>
          <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.28em] text-[#d42a2a]">
            Acceso seguro
          </p>
          <p className="mt-3 text-sm text-stone-600">Cargando la sesión…</p>
        </div>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  // Redirigir según rol
  if (user.role === 'admin') return <AdminPanel />;
  if (user.role === 'conductor') return <ConductorPanel />;
  if (user.role === 'vendedor') return <VendedorPanel />;
  return <PerfilSinPanel />;
}

export function App() {
  return (
    <AuthProvider>
      <AppRouter />
      <FeedbackHost />
    </AuthProvider>
  );
}

export default App;
